const initAMap = (plugins = []) => {
	// 获取全局对象
	const getWindow = () => {
		if (typeof global !== 'undefined') {
			return global;
		}
		return window;
	};

	getWindow()._AMapSecurityConfig = {
		securityJsCode: 'bb752d2fd5be152d0d7894d31b7653a9'
	};

	return new Promise((resolve, reject) => {
		if (getWindow().AMap) {
			resolve();
		} else {
			const script = document.createElement('script');
			const plugin = plugins?.length ? `&plugin=${plugins.join(',')}` : '';
			script.type = 'text/javascript';
			script.src = `//webapi.amap.com/maps?v=2.0&key=85ac59bc5d538700b77a0d3c55f05af7${plugin}`;
			script.onload = resolve;
			script.onerror = reject;
			document.body.append(script);
		}
	});
};

export default initAMap;
